module.exports = __webpack_public_path__ + "static/img/icon_5.fa164d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_5.png
// module id = uBGK
// module chunks = 0